import { clsx } from "clsx";
import { type CSSProperties, type FC, type PropsWithChildren, type ReactNode } from "react";

import style from "./styles/ContentPlaceholder.module.scss";
import styleLayout from "./styles/PageLayout.module.scss";

export interface IContentPlaceholderProps {
  /**
   * Use children instead
   * @deprecated
   */
  text?: ReactNode;
  className?: string;
  style?: CSSProperties;
  mini?: boolean;
}

const ContentPlaceholder: FC<PropsWithChildren<IContentPlaceholderProps>> = (props) => {
  return (
    <div
      className={clsx(
        { [styleLayout.page_container_middle]: props.mini !== true, [style.mini]: props.mini === true },
        props.className,
      )}
      style={props.style}
    >
      <div className={style.content}>{props.text ?? props.children}</div>
    </div>
  );
};

export { ContentPlaceholder };
